import React from 'react';
import { motion } from 'framer-motion';

const QuestionScreen = ({ question, onAnswer }) => {
  return (
    <motion.div
      key={question.id}
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.3 }}
      className="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl p-6 md:p-10 border border-gray-100"
    >
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 leading-tight">
        {question.question}
      </h2>

      <div className="space-y-3">
        {question.options.map((option, index) => (
          <button
            key={option.id}
            onClick={() => onAnswer(question.id, option.id)}
            className="w-full text-left p-5 rounded-xl border-2 border-gray-100 hover:border-blue-500 hover:bg-blue-50 transition-all duration-200 group flex items-center gap-4"
          >
            <div className="w-8 h-8 rounded-full border-2 border-gray-200 group-hover:border-blue-500 flex items-center justify-center text-sm font-medium text-gray-500 group-hover:text-blue-600 bg-white">
              {String.fromCharCode(65 + index)}
            </div>
            <span className="text-lg text-gray-700 group-hover:text-blue-900 font-medium">
              {option.text}
            </span>
          </button>
        ))}
      </div>
    </motion.div>
  );
};

export default QuestionScreen;